export default "__VITE_PUBLIC_ASSET__e765b030__"